<button [color]="isOn == 'menu' ? 'white' : 'primary'" #btn (click)="onclick.emit();" onclick="this.blur()"
    mat-icon-button class="df aic cp br5" [ngClass]="{'onboarading-menu' : mc.hiddenToUser, 'trigger-menu-desktop' : isOn == 'menu'}">
    <mat-icon>{{mc.lockmenu && mc.isDesktop ? 'menu_open' : 'menu'}}</mat-icon>
</button>